/* global google */
var youbora = require('youboralib')
var manifest = require('../../manifest.json')

youbora.adapters.AkamaiIma = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-IMA-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    var ret = 0
    if (this.flags.isJoined && this._adsManagerExists() &&
      this.player.proxy.adsManager.getRemainingTime) {
      ret = this.getDuration() - this.player.proxy.adsManager.getRemainingTime()
    }
    return ret
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this._currentAdExists()) {
      this.lastDuration = this.player.proxy.adsManager.getCurrentAd().getDuration()
    }
    return this.lastDuration
  },

  /** Override to return rendition */
  getRendition: function () {
    var ret = null
    if (this._currentAdExists()) {
      var currentAd = this.player.proxy.adsManager.getCurrentAd()
      ret = youbora.Util.buildRenditionString(currentAd.getVastMediaWidth(),
        currentAd.getVastMediaHeight())
    }
    return ret
  },

  /** Override to return title */
  getTitle: function () {
    var ret = null
    if (this._currentAdExists()) {
      ret = this.player.proxy.adsManager.getCurrentAd().getTitle()
    }
    return ret
  },

  /** Override to return title2 */
  getTitle2: function () {
    var ret = null
    if (this._currentAdExists()) {
      ret = this.player.proxy.adsManager.getCurrentAd().getAdvertiserName()
    }
    return ret
  },

  /** Override to return resource URL. */
  getResource: function () {
    var ret = null
    if (this._currentAdExists()) {
      ret = this.player.proxy.adsManager.getCurrentAd().getMediaUrl()
    }
    return ret
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return google.ima.VERSION
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'IMA'
  },

  getGivenBreaks: function () {
    if (!this.player.proxy) return null
    return this.player.proxy.adsManager.getCuePoints ? this.player.proxy.adsManager.getCuePoints().length : null
  },

  getBreaksTime: function () {
    if (!this.player.proxy || !this.player.proxy.adsManager || !this.player.proxy.adsManager.getCuePoints) {
      return null
    }
    var cuepoints = this.player.proxy.adsManager.getCuePoints()
    cuepoints.forEach(function (value, index) {
      if (cuepoints[index] === -1) {
        cuepoints[index] = Math.round(this.plugin._adapter.getDuration())
      }
    }.bind(this))
    return cuepoints
  },

  getGivenAds: function () {
    return this.totalAds
  },

  getAudioEnabled: function () {
    if (!this.player.proxy) return null
    return this.player.proxy.adsManager.getVolume ? this.player.proxy.adsManager.getVolume() !== 0 : true
  },

  getIsSkippable: function () {
    if (!this.player.proxy) return null
    return this.player.proxy.adsManager.getCurrentAd ? this.player.proxy.adsManager.getCurrentAd().g.skippable : false
  },

  getIsFullscreen: function () {
    if (!this.contentPlayer) {
      this.contentPlayer = this.plugin.getAdapter().player.viewComponent
    }
    if (this.contentPlayer && this.contentPlayer.clientWidth && this.contentPlayer.clientHeight) {
      return (window.innerHeight <= this.contentPlayer.clientHeight + 30 && window.innerWidth <= this.contentPlayer.clientWidth + 30)
    }
    return false
  },

  getIsVisible: function () {
    if (!this.contentPlayer) {
      this.contentPlayer = this.plugin.getAdapter().player.viewComponent
    }
    return youbora.Util.calculateAdViewability(this.contentPlayer)
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    if (this.plugin.getAdapter() && !this.plugin.getAdapter().flags.isJoined) {
      return youbora.Constants.AdPosition.Preroll
    }
    if (this.isDAI && this.plugin.getAdapter() && this.plugin.getAdapter().getIsLive()) return youbora.Constants.AdPosition.Midroll
    return this.adPosition || youbora.Constants.AdPosition.Midroll
  },

  getCreativeId: function () {
    var ret = null
    if (this._currentAdExists()) {
      ret = this.player.proxy.adsManager.getCurrentAd().g.creativeId
    }
    return ret
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // References
    this.references = {}
    this.monitorPlayhead(true, false)
    var event = google.ima.AdEvent.Type
    this.references[event.LOADED] = this.readyListener.bind(this)
    this.references[event.CONTENT_PAUSE_REQUESTED] = this.playListener.bind(this)
    this.references[event.LOADED] = this.playListener.bind(this)
    this.references[event.PAUSED] = this.pauseListener.bind(this)
    this.references[event.STARTED] = this.playingListener.bind(this)
    this.references[event.RESUMED] = this.playingListener.bind(this)
    this.references[google.ima.AdErrorEvent.Type.AD_ERROR] = this.errorListener.bind(this)
    this.references[event.COMPLETE] = this.endedListener.bind(this)
    this.references[event.CONTENT_RESUME_REQUESTED] = this.endedListener.bind(this)
    this.references[event.SKIPPED] = this.skippedListener.bind(this)
    this.references[event.CLICK] = this.clickListener.bind(this)
    this.references[event.ALL_ADS_COMPLETED] = this.endedViewListener.bind(this)
    this.references[event.LOG] = this.logListener.bind(this)
    this.references[event.CONTENT_RESUME_REQUESTED] = this.breakEndListener.bind(this)
    // Register listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.addEventListener(key, this.references[key])
      }.bind(this))
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    if (this.monitor) this.monitor.stop()
    // unregister listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.removeEventListener(key, this.references[key])
      }.bind(this))
      this.references = {}
    }
  },

  logListener: function (e) {
    if (e.getAdData() && e.getAdData()['adError']) {
      var error = e.getAdData()['adError']
      this.fireError(error.getErrorCode(), error.getMessage())
    }
  },

  /** Listener for 'play' and 'content_pause_requested' events. */
  playListener: function (e) {
    this.isDAI = false
    this.adPosition = this.getAdPosition()
    var adData = e.data.metadata.g
    this.totalAds = (adData && adData.adPodInfo) ? adData.adPodInfo.totalAds : null
    this.plugin.fireInit() // if preroll
    if (this.plugin.getAdapter()) this.plugin.getAdapter().firePause()
    this.fireStart({ adPlayhead: '0' })
    this.fireJoin({ adPlayhead: '0' })
    if (this._quartileTimer) delete this._quartileTimer
    this._quartileTimer = new youbora.Timer(this.quartileListener.bind(this), 1000)
    this._quartileTimer.start()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' and 'resume' events. */
  playingListener: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin({ adPlayhead: '0' })
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError()
    this.fireStop()
    if (this._quartileTimer) this._quartileTimer.stop()
  },

  /** Listener for 'ended' and 'content_resume_requested' events. */
  endedListener: function (e) {
    this.fireStop({ adPlayhead: this.lastDuration })
  },

  /** Listener for 'skipped' event. */
  skippedListener: function (e) {
    this.fireSkip({ adPlayhead: this.getPlayhead() })
    this._quartileTimer.stop()
  },

  /** Listener for 'click' event. */
  clickListener: function (e) {
    this.fireClick(e)
  },

  /** Listener for 'allAdsCompleted' event. */
  endedViewListener: function (e) {
    if (this.getPosition() === youbora.Constants.AdPosition.Postroll) {
      this.plugin.fireStop()
    }
  },

  readyListener: function (e) {
    this.totalAds = e.getAdData().adPodInfo.totalAds
  },

  breakEndListener: function (e) {
    this.fireBreakStop()
  },

  quartileListener: function (e) {
    var val = this.getPlayhead() / this.getDuration()
    if (val >= 0.25) {
      this.fireQuartile(1)
      if (val >= 0.5) {
        this.fireQuartile(2)
        if (val >= 0.75) {
          this.fireQuartile(3)
          this._quartileTimer.stop()
        }
      }
    }
  },

  getAdPosition: function () {
    var ret = youbora.Constants.AdPosition.Mdiroll
    switch (this.player.currentAd.position) {
      case 0:
        ret = youbora.Constants.AdPosition.Preroll
        break
      case -1:
        ret = youbora.Constants.AdPosition.Postroll
    }
    return ret
  },

  _adsManagerExists: function () {
    return this.player && this.player.proxy && this.player.proxy.adsManager
  },

  _currentAdExists: function () {
    return this._adsManagerExists() && this.player.proxy.adsManager.getCurrentAd()
  }
})

module.exports = youbora.adapters.AkamaiIma
